"use strict";

exports.__esModule = true;
exports.OTHER = exports.POST_LIST = exports.CATEGORY_LIST = void 0;
var CATEGORY_LIST = 'category-list';
exports.CATEGORY_LIST = CATEGORY_LIST;
var POST_LIST = 'post-list';
exports.POST_LIST = POST_LIST;
var OTHER = 'other';
exports.OTHER = OTHER;